import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const EstimatedArrivalSection = ({ estimatedTime, preparationTime, deliveryTime }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); // Update every minute

    return () => clearInterval(timer);
  }, []);

  // Calculate estimated arrival time
  const calculateArrivalTime = () => {
    const totalMinutes = preparationTime + deliveryTime;
    const arrivalTime = new Date(currentTime?.getTime() + totalMinutes * 60000);
    return arrivalTime?.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: true 
    });
  };

  return (
    <div className="bg-gradient-to-br from-accent/10 to-primary/10 rounded-xl shadow-lg p-4 md:p-6 lg:p-8 border border-accent/30">
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 bg-accent rounded-lg flex items-center justify-center">
          <Icon name="Clock" size={20} color="white" />
        </div>
        <h2 className="text-lg md:text-xl lg:text-2xl font-bold text-foreground">Estimated Arrival</h2>
      </div>

      <div className="text-center mb-6 md:mb-8">
        <div className="inline-flex items-center gap-2 mb-2">
          <Icon name="Timer" size={24} color="var(--color-primary)" />
          <span className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary">
            {estimatedTime}
          </span>
        </div>
        <p className="text-sm md:text-base text-muted-foreground">
          Expected delivery by <span className="font-semibold text-foreground">{calculateArrivalTime()}</span>
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3 md:gap-4 mb-4 md:mb-6">
        <div className="bg-card rounded-lg p-3 md:p-4">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="ChefHat" size={16} color="var(--color-primary)" />
            <span className="text-xs md:text-sm font-semibold text-foreground">Preparation</span>
          </div>
          <p className="text-lg md:text-xl font-bold text-primary">{preparationTime} min</p>
        </div>
        <div className="bg-card rounded-lg p-3 md:p-4">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Truck" size={16} color="var(--color-accent)" />
            <span className="text-xs md:text-sm font-semibold text-foreground">Delivery</span>
          </div>
          <p className="text-lg md:text-xl font-bold text-accent">{deliveryTime} min</p>
        </div>
      </div>

      <div className="bg-card rounded-lg p-3 md:p-4">
        <div className="flex gap-2 md:gap-3">
          <Icon name="Info" size={16} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <div className="text-xs md:text-sm text-muted-foreground">
            <p className="mb-1">
              <span className="font-semibold text-foreground">Traffic Buffer Included:</span> Times may vary based on current traffic conditions in South Sudan.
            </p>
            <p>
              We'll notify you via WhatsApp if there are any significant delays.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EstimatedArrivalSection;